import { render } from "./App.vue?vue&type=template&id=68764649"
const script = {}

import "./App.vue?vue&type=style&index=0&id=68764649&lang=css"
script.render = render

export default script